import { render } from "./EditPassenger.vue?vue&type=template&id=2822367a"
import script from "./EditPassenger.vue?vue&type=script&lang=js"
export * from "./EditPassenger.vue?vue&type=script&lang=js"

import "./EditPassenger.vue?vue&type=style&index=0&id=2822367a&lang=css"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__